import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await api.post("/subscribers/newsletter", { email });
      setStatus("done");
      setEmail("");
    } catch (err) {
      setStatus("error");
    }
  };

  if (status === "done") {
    return <p data-testid="home-newsletter-success" className="text-[#1E3A6E] font-semibold text-sm">You're on the list — thank you for joining the movement.</p>;
  }

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md">
        <Input
          type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="home-newsletter-email-input"
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none"
        />
        <Button type="submit" disabled={status === "loading"} data-testid="home-newsletter-submit-button" className="bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5] whitespace-nowrap">
          {status === "loading" ? "Joining..." : "Get Updates"}
        </Button>
      </form>
      <p className="text-xs text-zinc-500 mt-2 max-w-md">
        By signing up, you agree to receive updates from BBAP. Unsubscribe anytime. See our{" "}
        <Link to="/privacy" className="underline hover:text-zinc-950">Privacy Policy</Link>.
      </p>
    </div>
  );
}

export default function NewsletterSection() {
  return (
    <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
      <Heart className="h-8 w-8 text-[#1E3A6E] mx-auto mb-4" />
      <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl text-zinc-950 tracking-tight mb-3">
        Not ready to sign up? Just get updates.
      </h2>
      <p className="text-zinc-600 mb-6 max-w-lg mx-auto">
        Join the movement — get updates on new features, advocacy wins, and how the data is driving change.
      </p>
      <div className="flex justify-center">
        <NewsletterForm />
      </div>
    </section>
  );
}
